<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/U5h17F/tc-custom/9781452125114.jpg?1737758515140" alt="This image is the cover for the book Delicious Dips"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Delicious Dips
      </h1>
      <p class="bookDescription body article font2">
        <b>The James Beard Award–winning author of <i>Roots</i> and <i>Salmon</i> offers more than fifty original recipes for fun, festive dips and chips.</b><br/><br/>Diane Morgan—the diva of dips and champion of chips—has created more than fifty recipes for everyone’s dipping and dunking party favorites. Guests will make a beeline for lip-buzzing salsas scooped up with crispy tortilla triangles. Onion dip made from scratch is even better with homemade potato chips. And how about crunchy Parmesan Breadsticks for dunking into a butternut squash with creme fraiche?<br/><br/>Simple “Dip Do-Aheads” make prep work a snap, while dip tips and easy chip-making techniques make it easier—and tastier—than the typical store-bought alternatives. Let the party begin with <i>Delicious Dips</i>!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Diane Morgan, Joyce Oudkerk Pool
      </h2>
      
      <p class="authorDescription body article">Diane Morgan is an experienced cooking teacher and the author of many cookbooks, including the best-selling Atomic Cocktails (0-8118-1926-4), Midnight Munchies (0-8118-3534-0), Dressed to Grill (0-8118-3139-6), and The Thanksgiving Table (0-8118-2991-X), all from Chronicle Books. She lives in Portland, Oregon.Joyce Oudkerk Pool is an award-winning photographer specializing in food. Her photographs appear in a number of cookbooks including James McNair's New Pizza (0-8118-2364-4).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?385e3a4f